import React from 'react';
import { styled, createGlobalStyle } from 'styled-components';
import bottomBg from '../assets/grid_bottom_bg.png';
import HudLogo from '../assets/HudLogo.svg?react';
import { Button } from '../../Button/Button';
import { themeColor } from '../../theme/colors';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 500px;

  .caption {
    color: ${themeColor('textPrimary')};
    margin: 20px 0;
  }

  a:has(.signUp),
  .signUp {
    width: 100%;
    text-align: center;
    justify-content: center;
  }

  svg {
    color: ${themeColor('textPrimary')};
  }
`;

const GlobalStyle = createGlobalStyle`
  html:has(.unregisteredContainer) {
    height: 100%;
  }

  body:has(.unregisteredContainer) {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    background-color: ${themeColor('backgroundDark')};
    background-image: url(${bottomBg});
    background-position: bottom center;
    background-repeat: no-repeat;
  }
`;

export default function UnregisteredPage() {
  return (
    <Container className="unregisteredContainer">
      <HudLogo />
      <div className="caption">
        It seems you do not yet have an account with us.
      </div>
      <a href="https://www.hud.io">
        <Button variant={'glow'} className="signUp">
          Sign-Up for early access
        </Button>
      </a>
      <GlobalStyle />
    </Container>
  );
}
